<script>
import formatDate from '@utils/format-date'
import  { formatOrder } from "@utils/format-order";
import {
  prepaidUsedStepList
} from "@utils/ipetbooking-prepaid";

export default {
  components: {
    ListHistoryJtails: () => import("@components/List/ListHistory.Jtails"),
  },
  props: {
    orderItem: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      displayCancel: this.$route.query.displayCancel === 'true' || false,
      reverse: true,
      activeStep: 0,
    }
  },
  computed: {
    historyList() {
      return this.orderItem.history.filter(({status}) => status !== 0)
    },
    historyCancelList() {
      return this.orderItem.history.filter(item => {
        return item.status === 0
      })
    }
  },
  watch: {
    'orderItem.used': {
      handler(val) {
        this.activeStep = val - 1
      },
      immediate: true,
    }
  },
  methods: {
    formatOrder,
    formatDate,
    goToMemberReservationItem(item) {
      this.$router.push({
        name: 'member-reservation-item',
        params: {
          orderId: item.id,
          containerUuid:item.containerId
        }
      })
    },
    stepList(orderItem) {
      return prepaidUsedStepList({
        ...orderItem
      })
    },
    openDialogReservation(reservationItem) {
      this.$globalDialog('DialogReservation', {
        ...reservationItem
      })
    },
  }
}
</script>
<!-- section template -->
<template>
  <div :class="$style.reservationItemSectionItemHistory">
    <template v-if="!!orderItem.history[0]">
      <div
        class="usedList mb-5 mt-4"
      >
      <!--<BaseStepJtails
          v-model="activeStep"
          :step-list="stepList(orderItem)"
          type="history"
        />-->
        <ListHistoryJtails
          v-model="activeStep"
          type="history"
          :history-list="stepList(orderItem)"
        />
        <div :class="$style.orderList">
          <template v-for="(historyItem, index) in historyList">
            <div class="orderList__applicableWrapper" :class="{ 'd-none': index !== activeStep }" :key="`orderListItem-${index}`">
              <div class="orderList__applicableHead">
                <div>預約時間：{{ formatDate(historyItem.startDate, 'yyyy/MM/dd HH:ss') }}</div>
                <div class="text-right">訂單成立時間：{{ formatDate(historyItem.createdDate, 'yyyy/MM/dd HH:ss') }}</div>
              </div>
              <hr class="orderList__applicableHr">
              <div
                class="orderList__item"
              >
                <div class="orderList__contentBox">
                  <div class="d-inline-block mb-1 mb-md-0">
                    <el-tag class="isStyleDark isOutline isSmall mr-3">
                      {{ historyItem.store.title }}
                    </el-tag>
                  </div>
                  <div class="d-inline-block mb-1 mb-md-0">
                    <span
                      class="orderList__title"
                      @click="openDialogReservation(historyItem.param)"
                    >
                    {{ historyItem.param.title }}
                  </span>
                  </div>
                  <span  v-if="$globalCategoryVisible" class="orderList__meta">
                    {{ historyItem.param.categoryTitle }} | {{ historyItem.param.sizeTitle }}
                  </span>
                </div>
                <div class="orderList__buttonBox">
                  <BaseButton
                    class="isStylePrimary isText seeBtn d-none d-md-block"
                    @click="goToMemberReservationItem(historyItem)"
                  >
                    <i class="fontello fontello-view fs-2xl"></i>
                  </BaseButton>
                  <BaseButton
                    class="isStyleSecondary isSmall isRadius isFull isOutline2 d-md-none "
                    @click="goToMemberReservationItem(historyItem)"
                  >
                    查看訂單
                  </BaseButton>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>

      <el-collapse v-if="!!historyCancelList.length" class="isStyleBase">
        <el-collapse-item title="已取消訂單">
          <div :class="$style.orderList">
            <template v-for="(historyItem, index) in historyCancelList">
              <div :key="`historyCancelList-${index}`" :class="$style.mark">
                已取消
              </div>
              <div class="orderList__applicableWrapper isCancel" :key="`orderListItem-${index}`">
                <div class="orderList__applicableHead">
                  <div>預約時間：{{ formatDate(historyItem.startDate, 'yyyy/MM/dd HH:ss') }}</div>
                  <div class="text-right">訂單成立時間：{{ formatDate(historyItem.createdDate, 'yyyy/MM/dd HH:ss') }}</div>
                </div>
                <hr class="orderList__applicableHr">
                <div
                  class="orderList__item"
                >
                  <div class="orderList__contentBox">
                    <el-tag class="isStyleDark isOutline isSmall mr-3">
                      {{ historyItem.store.title }}
                    </el-tag>
                    <span class="orderList__title" @click="openDialogReservation(historyItem.param)">{{ historyItem.param.title }}</span>
                    <span  v-if="$globalCategoryVisible" class="orderList__meta">
                        {{ historyItem.param.categoryTitle }} | {{ historyItem.param.sizeTitle }}
                      </span>
                  </div>
                  <div class="orderList__buttonBox">
                    <BaseButton
                      class="isStylePrimary isText seeBtn"
                      @click="goToMemberReservationItem(historyItem)"
                    >
                      <i class="fontello fontello-view fs-3xl"></i>
                    </BaseButton>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </el-collapse-item>
      </el-collapse>
  
    </template>
    <template v-else>
      <BaseNull
        :image="`${ require(`@assets/images/${$globalProjectName}/reservation/no-service.svg`) }`"
        title="尚未開始使用"
      />
    </template>
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.reservationItemSectionItemHistory {
  :global {
    .reservationItemSectionItemHistory {
      @include unstyled;
    }
    .usedList {
      width: 100%;
      padding: 1.875em;
      border: 1px solid $color-line;
    }
  }
}

.timelineList {
  :global {
    .timelineList {
      &__item {
        @include unstyled;
      }

      &__title {
        font-size: 1rem;

        @include max-md {
          margin-bottom: 0.5rem;
          font-size: 0.875rem;
          color: $color-blue-dark;
        }
      }

      &__date {
        font-size: 0.75rem;
        color: #687580;
        letter-spacing: 0.1em;

        @include max-md {
          margin-bottom: 0.5rem;
        }
      }

      &__used {
        @include max-md {
          margin-bottom: 0.5rem;
          font-size: 0.875rem;
          color: $color-blue-dark;
        }

      }

      &__time {
        br {
          @include max-md {
            display: none;
          }
        }

      }
    }

    .seeBtn {
      @include max-md {
        position: absolute;
        top: 0;
        right: 0;
      }
    }
  }
}

.orderList {
  :global {
    .orderList {
      &__applicableWrapper {
        padding: 1.25rem 1.5rem 1rem;
        background: #fff;
        box-shadow: 0 1px 16px rgba(0, 0, 0, 0.12);
        &.isCancel {
          margin-right: 0.75rem;
          margin-bottom: 3rem;
          margin-left: 3.125rem;

          @include max-md {
            margin-right: 0.75rem;
            margin-bottom: 2rem;
            margin-left: 0.75rem;
          }
        }
      }

      &__applicableHead {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 0.75rem;
        line-height: 1.75;
        color: #726F65;

        @include max-md {
          flex-direction: column;
          align-items: flex-start;
        }
      }

      &__applicableHr {
        margin: 1rem 0;
      }

      &__item {
        display: flex;
        justify-content: space-between;
        padding: 1rem 0;

        @include max-md {
          flex-direction: column;
        }

        &:not(:last-child) {
          border-bottom: 1px solid $color-line;
        }
      }

      &__contentBox {
        padding-top: 0.5rem;

        @include max-md {
          display: flex;
          flex-direction: column;
          padding-top: 0.5rem;
          padding-bottom: 0.5rem;
        }
      }

      &__buttonBox {
        @include unstyled;
      }

      &__title {
        padding-bottom: 3px;
        font-size: 0.875rem;
        color: #3F3A2E;
        cursor: pointer;
        border-bottom: 1px solid #3F3A2E;
        &:hover {
          color: $color-primary;
          border-bottom-color: $color-primary;
        }
      }

      &__meta {
        margin-left: 1rem;
        font-size: 0.75rem;
        color: #726F65;

        @include max-md {
          margin-left: 0;
        }
      }
    }
  }
}

.mark {
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 0.6rem;

  &::before {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    padding-left: 3px;
    margin-right: 0.9rem;
    font-family: $font-fontello;
    font-size: 1.25rem;
    font-weight: 500;
    color: $color-line;
    content: "\E812";
    border: 2px solid $color-line;
    border-radius: 100%;
    transform: rotate(-30deg);
  }

  @include max-md {
    display: none;
  }
}
</style>
